import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)] font-sans w-full" }
const _hoisted_2 = {
  key: 1,
  class: "w-full fixed z-40 -mt-2 mb-8"
}
const _hoisted_3 = {
  key: 2,
  class: "bg-[var(--bg)] group"
}
const _hoisted_4 = { class: "container mx-auto px-12 text-center sm:px-24" }
const _hoisted_5 = { class: "flex flex-col justify-between w-full py-16 mb-8 sm:flex-row sm:items-start" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex space-x-12 mr-0 opacity-30 group-hover:opacity-100 transition-all duration-500 ease-in-out sm:mr-20 sm:mx-0 sm:space-x-20" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "flex justify-between items-center border-t border-[var(--border)] pt-8 pb-20" }
const _hoisted_15 = { class: "text-xs text-[var(--text-secondary)] font-light" }
const _hoisted_16 = ["src"]

import {
  defineAsyncComponent,
  computed,
  ref,
  onMounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const Notifications = defineAsyncComponent(() => import('./components/global/notifications.vue'));
const NavBar = defineAsyncComponent(() => import('./components/global/navbar.vue'));
const Sidebar = defineAsyncComponent(() => import('./components/global/sidebar.vue'));

const store = useStore();
const route = useRoute();

const skyAppLink = ref(process.env.VUE_APP_SKY_URL);
const firewebAppLink = ref(process.env.VUE_APP_URL_DG_FIREWEB_APP);
const careAppLink = ref(process.env.VUE_APP_URL_DG_CARE_APP);
const utilsAppLink = ref(process.env.VUE_APP_UTILS_URL);

const showSidebar = computed(() => store.state.sidebar);
const shouldShowNavbar = computed(() => !route.path.startsWith('/auth'));
const shouldShowFooter = computed(() => !route.path.startsWith('/auth'));
const isLight = computed(() => store.state.theme.theme === 'light');

const currentYear = ref(new Date().getFullYear());

const toggleTheme = () => {
  store.dispatch('theme/toggleTheme');
  const newTheme = store.state.theme.theme;

  document.documentElement.classList.toggle('light', newTheme === 'light');
};

function toggleSidebar() {
  store.commit('toggleSidebar');
}

function clickOutside() {
  if (showSidebar.value) store.commit('toggleSidebar');
}

onMounted(() => {
  if (typeof window !== 'undefined') {
    // Phase 1: Core Signals Collection
    store.dispatch('device/generateFingerprint').catch((err) => {
      console.warn('Could not generate device fingerprint', err);
    });
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Notifications)),
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-30",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    (shouldShowNavbar.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(NavBar)),
          _createVNode(_unref(Sidebar))
        ])), [
          [_directive_click_outside, clickOutside]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["min-h-[calc(100vh-4rem)]", {
        'pt-10': shouldShowNavbar.value
      }])
    }, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.fullPath
      }))
    ], 2),
    (shouldShowFooter.value)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full h-px bg-line" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: _ctx.isAuth ? '/app' : '/',
                class: "mb-10 sm:mb-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: isLight.value
                ? '/img/logo-digi-light.svg'
                : '/img/logo-digi.svg',
                    alt: "Logo",
                    class: "h-6 opacity-30 group-hover:opacity-100 courser-pointer"
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Products", -1)),
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: skyAppLink.value,
                        target: "_blank",
                        class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                      }, "Sky ", 8, _hoisted_10)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: firewebAppLink.value,
                        target: "_blank",
                        class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                      }, "Fireweb ", 8, _hoisted_11)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: careAppLink.value,
                        target: "_blank",
                        class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                      }, "Care ", 8, _hoisted_12)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: utilsAppLink.value,
                        target: "_blank",
                        class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                      }, "Utils ", 8, _hoisted_13)
                    ])
                  ])
                ]),
                _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"text-left\" data-v-a84893ee><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-a84893ee>Contact Us</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-a84893ee><li data-v-a84893ee><a href=\"https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=support@digiapps.com.co\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-a84893ee>Help Center </a></li><li data-v-a84893ee><a href=\"https://discord.gg/n8NHa6sJbc\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-a84893ee>Discord </a></li></ul></div><div class=\"text-left\" data-v-a84893ee><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-a84893ee>Legal</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-a84893ee><li data-v-a84893ee><a href=\"/privacy-policy\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-a84893ee>Privacy Policy </a></li></ul></div>", 2))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, "© " + _toDisplayString(currentYear.value) + " digi systems All rights reserved.", 1),
              _createElementVNode("button", {
                onClick: toggleTheme,
                class: "rounded-full"
              }, [
                _createElementVNode("img", {
                  src: isLight.value
                ? '/icon/icon-light.svg'
                : '/icon/icon-dark.svg',
                  alt: "theme toggle",
                  class: "w-5 h-5 opacity-70 hover:opacity-100 transition"
                }, null, 8, _hoisted_16)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})